import { bootstrapApplication } from '@angular/platform-browser';
import Bolt from '@nationwide-bolt/bundle-core';

import { App } from '@components/app';
import { applicationConfig } from '@config/application.config';

await (Bolt as { initialize: () => Promise<void> }).initialize();
await bootstrapApplication(App, applicationConfig);
